import sharedEnv from './sharedEnv';
import {apiService} from '../services/apiService';

const listeners = new Set();
let lastLoaded = null;

export function subscribeSettings(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function getLoadedSettings() {
  return lastLoaded;
}

function fileURL(p) {
  if (!p) return null;
  return `${sharedEnv.baseURL}/${p}`;
}

function applyToSharedEnv(s) {
  if (s.logo) sharedEnv.logoUrl = fileURL(s.logo);
  if (s.favicon) sharedEnv.faviconUrl = fileURL(s.favicon);
  if (s.backgroundImage) sharedEnv.backgroundImageUrl = fileURL(s.backgroundImage);
  if (s.introText && s.introText.el) sharedEnv.introTextGR = s.introText.el;
  if (s.introText && s.introText.en) sharedEnv.introTextEN = s.introText.en;
  if (s.hrefLink) sharedEnv.hrefLink = s.hrefLink;
  if (s.hrefAlt) sharedEnv.hrefAlt = s.hrefAlt;
  if (s.shareQuote) sharedEnv.shareQuote = s.shareQuote;
  if (typeof s.hidePeriodsBottomBar === 'boolean') sharedEnv.hidePeriodsBottomBar = s.hidePeriodsBottomBar;
  if (typeof s.hideYearSuffix === 'boolean') sharedEnv.hideYearSuffix = s.hideYearSuffix;
  if (typeof s.useUppercasePeriodName === 'boolean') sharedEnv.useUppercasePeriodName = s.useUppercasePeriodName;
}

export async function loadAndApplySettings() {
  try {
    const s = await apiService.getSettings();
    if (s && Object.keys(s).length) {
      applyToSharedEnv(s);
      lastLoaded = s;
    } else {
      lastLoaded = {};
    }
  } catch (e) {
    // keep env defaults
  }
  listeners.forEach(fn => fn());
  return lastLoaded;
}
